"use client";

import OpenToWorkImageLight from "@themedImages/light/openToWork.png";
import OpenToWorkImageNight from "@themedImages/night/openToWork.png";
import OpenToWorkImageEndemic from "@themedImages/endemic/openToWork.png";
import { Theme } from "@/shared/constants";

export type ImageNames = "open-to-work";

type ThemedImages = Record<ImageNames, Record<Theme, any>>;

export const IMAGES: ThemedImages = {
  "open-to-work": {
    [Theme.Light]: OpenToWorkImageLight,
    [Theme.Night]: OpenToWorkImageNight,
    [Theme.Endemic]: OpenToWorkImageEndemic,
  },
};
